var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.title")) + " ")]), !_vm.value.isCompleted ? _c('v-card-subtitle', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.subtitle")) + " ")]), _vm.value.date ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("thg.PriceTable.to", {
    date: _vm.simpleDoubleDigitDate(_vm.value.date)
  })) + " ")]) : _vm._e()], 1) : _c('v-card-subtitle', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.repliedSubtitle")) + " ")])]), _vm.value.isCompleted ? _c('v-card-text', [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "success"
    }
  }, [_vm._v(" mdi-check-circle-outline ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.replied")) + " ")]), _c('v-list-item-subtitle', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.number")) + ": " + _vm._s(_vm.value.number) + " ")]), _c('span', [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.total")) + ": " + _vm._s(_vm.formatCurrency(_vm.value.total, _vm.value.currency)) + " ")])])], 1)], 1)], 1) : _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "info",
      "elevation": 0
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("repairEstimateRequest.response.makeOffer")) + " ")])], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "title": _vm.$t('repairEstimateRequest.response.makeOffer'),
      "subtitle": _vm.$t('repairEstimateRequest.response.makeOfferSubtitle'),
      "loading": _vm.loading,
      "rightLoading": _vm.loading,
      "rightDisabled": !_vm.isValid,
      "hideRight": _vm.step === _vm.CreateInvoiceWindow.FILE,
      "leftText": _vm.leftText,
      "rightText": _vm.$t('repairEstimateRequest.response.confirmOffer')
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": _vm.leftClick,
      "rightClick": _vm.confirmRepairEstimateResponse
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-window', {
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.CreateInvoiceWindow.FILE
    }
  }, [_c('drop-area-multi', {
    staticClass: "my-2",
    attrs: {
      "files": _vm.files,
      "text": _vm.$t('cost.dragAndDropDocuments'),
      "dragoverText": _vm.$t('sign.SignDocumentCreateDialog.title'),
      "loading": _vm.loading,
      "accept": ".pdf",
      "maxFiles": 1
    },
    on: {
      "update:files": function updateFiles($event) {
        _vm.files = $event;
      }
    }
  })], 1), _c('v-window-item', {
    staticClass: "pt-2",
    attrs: {
      "value": _vm.CreateInvoiceWindow.FIELDS
    }
  }, [_c('v-text-field', {
    ref: "startField",
    attrs: {
      "label": _vm.$t('objects.repairEstimateRequest.number'),
      "hint": _vm.$t('objects.repairEstimateRequest.numberHint'),
      "persistent-hint": true,
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.valueCopy.number,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "number", $$v);
      },
      expression: "valueCopy.number"
    }
  }), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "label": _vm.$t('objects.repairEstimateRequest.total'),
      "hint": _vm.$t('objects.repairEstimateRequest.totalHint'),
      "persistent-hint": true,
      "type": "number",
      "min": 0,
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.valueCopy.total,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "total", _vm._n($$v));
      },
      expression: "valueCopy.total"
    }
  }), _c('v-autocomplete', {
    staticClass: "ml-1",
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "label": _vm.$t('objects.repairEstimateRequest.currency'),
      "clearable": "",
      "outlined": "",
      "return-object": "",
      "items": Object.values(_vm.CurrencyEnum),
      "auto-select-first": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "filter": _vm.getAutocompleteFilter(function (e) {
        return [e];
      })
    },
    model: {
      value: _vm.valueCopy.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.valueCopy, "currency", $$v);
      },
      expression: "valueCopy.currency"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }